export class ChangeMaterialAction {

  public readonly materialName: string;

  constructor(materialName: string) {
    this.materialName = materialName;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/ChangeMaterialAction.ts